import * as constants from './constants';

export const getCategories = (payload) => ({ type: constants.GET_CATEGORIES, payload });
export const resetCategories = () => ({ type: constants.RESET_CATEGORIES });
export const getCategoriesSuccess = (payload) => ({
  type: constants.GET_CATEGORIES_SUCCESS,
  payload,
});
export const getCategoriessError = (payload) => ({
  type: constants.GET_CATEGORIES_ERROR,
  payload,
});

export const getUserCategories = () => ({ type: constants.GET_USER_CATEGORIES });
export const getUserCategoriesSuccess = (payload) => ({
  type: constants.GET_USER_CATEGORIES_SUCCESS,
  payload,
});
export const getUserCategoriesError = (payload) => ({
  type: constants.GET_USER_CATEGORIES_ERROR,
  payload,
});
export const resetUserCategories = () => ({ type: constants.RESET_USER_CATEGORIES });

export const addUserCategory = (payload) => ({ type: constants.ADD_USER_CATEGORY, payload });
export const addUserCategorySuccess = () => ({
  type: constants.ADD_USER_CATEGORY_SUCCESS,
});
export const addUserCategoryError = (payload) => ({
  type: constants.ADD_USER_CATEGORY_ERROR,
  payload,
});

// eslint-disable-next-line max-len
export const removeUserCategory = (payload) => ({ type: constants.REMOVE_USER_CATEGORY, payload });
export const removeUserCategorySuccess = () => ({
  type: constants.REMOVE_USER_CATEGORY_SUCCESS,
});
export const removeUserCategoryError = () => ({
  type: constants.REMOVE_USER_CATEGORY_ERROR,
});
